
export const es = {
  // Menu
  "menu.dashboard": "Dashboard",
  "menu.announcements": "Comunicados",
  "menu.transparency": "Transparencia",
  "menu.access": "Accesos y QR",
  "menu.amenities": "Amenidades",
  "menu.payments": "Pagos y Finanzas",
  "menu.cobranza": "Cobranza",
  "menu.polls": "Encuestas",
  "menu.incidents": "Reportes e Incidencias",
  "menu.documents": "Documentos",
  "menu.logout": "Cerrar Sesión",
  "menu.admin": "Administración",
  "menu.directory": "Directorio",
  "menu.restrictions": "Restricciones",
  "menu.emergency": "Emergencias",
  "menu.notifications": "Notificaciones",
  "menu.profile": "Mi Perfil",
  "menu.settings": "Configuración",
  "menu.help": "Ayuda",
  "menu.logoutTitle": "Cerrar Sesión",
  "menu.logoutMessage": "¿Estás seguro de querer cerrar sesión?",
  "menu.version": "Versión 1.0.0",
  "menu.reports": "Reportes",
  "menu.logbook": "Bitácora",
  "menu.patrol": "Patrullaje",
  "menu.suppliers": "Proveedores",
  "menu.inventory": "Inventario",
  "menu.cameras": "Cámaras en Vivo",

  // Menu Categories
  "menu.categories.main": "Principal",
  "menu.categories.community": "Comunidad",
  "menu.categories.access": "Acceso",
  "menu.categories.engagement": "Comunicación",
  "menu.categories.finances": "Finanzas",
  "menu.categories.security": "Seguridad",
  "menu.categories.operations": "Operaciones",
  "menu.categories.admin": "Administración",
  "menu.categories.configuration": "Configuración",

  // Documents
  "docs.title": "Biblioteca de Documentos",
  "docs.upload": "Subir Documento",
  "docs.empty": "No hay documentos disponibles.",
  "docs.cat.bylaws": "Reglamentos",
  "docs.cat.minutes": "Actas de Asamblea",
  "docs.cat.financial": "Estados Financieros",
  "docs.cat.notices": "Avisos",
  "docs.cat.insurance": "Pólizas y Seguros",
  "docs.cat.other": "Otros",
  "docs.upload.modal": "Publicar Documento",
  "docs.upload.title": "Título del Archivo",
  "docs.upload.category": "Categoría",
  "docs.upload.file": "Seleccionar Archivo",

  // Profile
  "profile.title": "Mi Hogar",
  "profile.tab.info": "Datos Personales",
  "profile.tab.family": "Familia y Residentes",
  "profile.tab.vehicles": "Vehículos",
  "profile.tab.pets": "Mascotas",
  "profile.role": "Tipo de Residente",
  "profile.unit": "Unidad",
  "profile.member.add": "Agregar Miembro",
  "profile.member.name": "Nombre",
  "profile.member.relation": "Relación",
  "profile.member.age": "Edad",
  "profile.relation.spouse": "Cónyuge",
  "profile.relation.child": "Hijo/a",
  "profile.relation.parent": "Padre/Madre",
  "profile.relation.staff": "Personal Servicio",
  "profile.relation.other": "Otro",
  "profile.family.fullName": "Nombre completo",
  "profile.family.age": "Edad",
  "profile.family.relation": "Relación",
  "profile.family.emailNote": "Se enviará un enlace de acceso a este correo",
  "profile.family.description": "Miembros del hogar con acceso a la unidad",
  "profile.family.registerTitle": "Registrar miembro del hogar",
  "profile.family.add": "Agregar miembro",
  "profile.family.empty": "No hay miembros del hogar registrados",
  "profile.family.accountActive": "Cuenta activa",
  "profile.family.permanentAccess": "Acceso permanente",
  "profile.family.resendInvite": "Reenviar invitación",
  "profile.family.viewQr": "Ver QR",
  "profile.vehicle.plate": "Placa",
  "profile.vehicle.alias": "Alias / Modelo",
  "profile.vehicle.status": "Estado Acceso",
  "profile.pets.add": "Registrar Mascota",
  "profile.pets.empty": "No hay mascotas registradas.",
  "profile.pets.type": "Tipo",
  "profile.pets.breed": "Raza",
  "profile.pets.color": "Color",
  "profile.pets.age": "Edad",
  "profile.pets.vaccines": "Vacunas",
  "profile.pets.tag": "Placa Digital",
  "profile.pets.tag_desc": "Escanea este código para ver información de contacto del dueño.",
  "profile.pets.modal.title": "Datos de la Mascota",
  "profile.pets.modal.name": "Nombre",
  "profile.pets.modal.chip": "ID Chip / Registro",
  "profile.pets.vaccine.add": "Agregar Vacuna",
  "profile.pets.vaccine.name": "Nombre Vacuna",
  "profile.pets.vaccine.date": "Fecha Aplicación",
  "profile.pets.title": "Mascotas",
  "profile.pets.name": "Nombre",
  "profile.pets.description": "Registra las mascotas de tu hogar",
  "profile.pets.lostScanHere": "Escanea este código para ver información de contacto del dueño.",
  "profile.vehicles.add": "Agregar vehículo",
  "profile.vehicles.description": "Vehículos registrados en tu hogar",
  "profile.vehicles.makeModel": "Marca / Modelo",
  "profile.vehicles.makeModelPlaceholder": "Ej. Honda Civic 2023",
  "profile.vehicles.plateNumber": "Número de placa",
  "profile.vehicles.register": "Registrar",
  "profile.vehicles.registerTitle": "Registrar vehículo",
  "profile.fiscal.title": "Datos Fiscales",
  "profile.fiscal.businessName": "Razón Social",
  "profile.fiscal.taxRegime": "Régimen Fiscal",
  "profile.fiscal.zipCode": "Código Postal",
  "profile.fiscal.address": "Dirección",
  "profile.fiscal.email": "Correo Electrónico",
  "profile.fiscal.registerNow": "Registrar ahora",
  "profile.security": "Seguridad",
  "profile.changePassword": "Cambiar Contraseña",
  "profile.currentPassword": "Contraseña Actual",
  "profile.newPassword": "Nueva Contraseña",
  "profile.confirmPassword": "Confirmar Contraseña",
  "profile.passwordChanged": "Contraseña cambiada correctamente",
  "profile.passwordMismatch": "Las contraseñas no coinciden",
  "profile.passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
  "profile.incorrectPassword": "La contraseña actual es incorrecta",
  "profile.contact.title": "Información de Contacto",
  "profile.phone.label": "Teléfono",
  "profile.phone.updated": "Teléfono actualizado correctamente",
  "profile.status.ACTIVE": "Activo",
  "profile.status.INACTIVE": "Inactivo",
  "profile.status.BLOCKED": "Bloqueado",
  "profile.status.blocked": "Bloqueado",
  "profile.security.title": "Seguridad",
  "profile.password.change": "Cambiar Contraseña",
  "profile.password.current": "Contraseña Actual",
  "profile.password.new": "Nueva Contraseña",
  "profile.password.confirm": "Confirmar Contraseña",
  "profile.password.changed": "Contraseña cambiada correctamente",
  "profile.password.mismatch": "Las contraseñas no coinciden",
  "profile.password.tooShort": "La contraseña debe tener al menos 6 caracteres",
  "profile.password.incorrect": "La contraseña actual es incorrecta",
  "profile.phone.notRegistered": "No se ha registrado un teléfono",
  "profile.avatar.updated": "Imagen de perfil actualizada correctamente",

  // Access Control
  "access.title": "Control de Accesos",
  "access.tab.my_qr": "Mi QR",
  "access.tab.guests": "Invitaciones",
  "access.tab.my_cards": "Mis Tarjetas",
  "access.tab.logs": "Historial",
  "access.tab.cameras": "Cámaras",
  "access.remote_open": "Apertura Remota",
  "access.remote_warning":
    "Solo use esta función si tiene visibilidad de la puerta.",
  "access.door.pedestrian": "Entrada Peatonal",
  "access.door.vehicle": "Portón Vehicular",
  "access.pin.title": "¿Olvidaste tu celular?",
  "access.pin.subtitle": "Tu PIN de acceso personal:",
  "access.pin.change": "Cambiar PIN",
  "access.pin.update_success": "PIN actualizado correctamente",

  // Guests
  "guest.create_btn": "Nueva Invitación",
  "guest.empty": "No tienes invitaciones activas.",
  "guest.subtitle":
    "Gestiona los accesos para tus visitas, servicios o paquetería.",
  "guest.form.title": "Crear Pase de Acceso",
  "guest.form.name": "Nombre del Visitante",
  "guest.form.name_ph": "Ej. Juan Pérez, DHL, Totalplay",
  "guest.form.type": "Tipo de Visita",
  "guest.form.validity": "Vigencia del Acceso",
  "guest.form.plate": "Placas (Opcional - LPR)",
  "guest.form.notes": "Notas para Guardia",
  "guest.form.submit": "Generar Acceso",
  "guest.form.cancel": "Cancelar",

  "guest.type.visit": "Visita Social",
  "guest.type.service": "Servicio / Mantenimiento",
  "guest.type.delivery": "Paquetería / Delivery",
  "guest.type.party": "Evento / Fiesta",

  "guest.validity.once": "Un solo uso (24h)",
  "guest.validity.range": "Rango de Fechas",
  "guest.validity.permanent": "Permanente (Familia/Staff)",

  "guest.status.active": "ACTIVO",
  "guest.status.expired": "VENCIDO",
  "guest.status.future": "PROGRAMADO",

  "guest.ticket.title": "Pase de Acceso",
  "guest.ticket.pin": "PIN DE ACCESO",
  "guest.ticket.share_msg": "Comparte este código con tu visita",
  "guest.ticket.valid_until": "Válido hasta:",

  // Logs
  "log.header.date": "Fecha y Hora",
  "log.header.user": "Usuario / Visitante",
  "log.header.method": "Método",
  "log.header.entry": "Punto de Acceso",
  "log.header.status": "Estado",
  "log.header.photos": "Fotos",
  "log.method.qr_resident": "QR Residente",
  "log.method.qr_guest": "QR Invitado",
  "log.method.qr_hik": "QR HIK",
  "log.method.lpr": "Lector de Placas",
  "log.method.manual": "Apertura Manual",
  "log.method.app_remote": "App Remota",
  "log.method.rfid": "RFID",
  "log.method.pin": "PIN",
  "log.method.remote_open": "Apertura Remota",
  "log.method.faceid": "Reconocimiento Facial",
  "log.status.granted": "Permitido",
  "log.status.denied": "Denegado",

  // Amenities
  "amenities.title": "Reservar Amenidades",
  "amenities.balance": "Saldo disponible",
  "amenities.book_btn": "Reservar Ahora",
  "amenities.capacity": "Cap",
  "amenities.free": "Sin costo",
  "amenities.deposit_req": "Requiere depósito",
  "amenities.no_deposit": "Sin depósito",
  "amenities.my_reservations": "Mis Reservaciones",
  "amenities.list.empty": "No tienes reservaciones próximas.",
  "amenities.list.date": "Fecha",
  "amenities.list.amenity": "Área",
  "amenities.list.cost": "Costo Total",
  "amenities.list.status": "Estado",
  "amenities.list.actions": "Acciones",
  "amenities.status.pending": "Pendiente",
  "amenities.status.confirmed": "Confirmado",
  "amenities.status.cancelled": "Cancelado",
  "amenities.cancel.modal_title": "Cancelar Reservación",
  "amenities.cancel.modal_body": "Estás a punto de cancelar tu reservación de <strong>{{amenity}}</strong> del <strong>{{date}}</strong>. Esta acción no se puede deshacer.",
  "amenities.cancel.keep": "Mantener Reservación",
  "amenities.cancel.confirm": "Sí, Cancelar",
  "amenities.cancel.error_message": "Error al cancelar la reservación",

  "amenities.errors.title": "Error",
  "amenities.errors.slotTaken": "Alguien más reservó ese horario. Por favor elige otra hora disponible.",

  // Amenity Wizard
  "amenities.wizard.title": "Asistente de Reservación",
  "amenities.wizard.step1": "Fecha y Hora",
  "amenities.wizard.step2": "Contrato",
  "amenities.wizard.step3": "Confirmación",
  "amenities.wizard.next": "Siguiente",
  "amenities.wizard.back": "Atrás",
  "amenities.slots.available": "Disponible",
  "amenities.slots.occupied": "Ocupado",
  "amenities.contract.title": "Reglamento y Términos",
  "amenities.contract.rules": "Reglas del Área",
  "amenities.contract.terms": "Términos y Condiciones",
  "amenities.contract.accept":
    "He leído y acepto el reglamento y términos de uso.",
  "amenities.payment.generating": "Generando cargo...",
  "amenities.payment.confirm_msg":
    "Al confirmar, se generará un cargo a tu cuenta que deberás cubrir en tu próximo estado de cuenta.",
  "amenities.success": "Reservación confirmada exitosamente",

  "amenities.modal.title": "Nueva Reservación",
  "amenities.modal.date": "Fecha",
  "amenities.modal.start_time": "Hora de Inicio",
  "amenities.modal.hours": "Duración (Horas)",
  "amenities.modal.summary": "Resumen de Costos",
  "amenities.modal.rental": "Renta",
  "amenities.modal.deposit": "Depósito (Reembolsable)",
  "amenities.modal.total": "Total a Pagar",
  "amenities.modal.confirm": "Confirmar y Pagar",

  "amenities.slots.selected": "Selección",
  "amenities.slots.past": "Pasado",

  // Amenity Wizard – missing keys
  "amenities.wizard.step": "Paso",
  "amenities.wizard.of": "de",
  "amenities.wizard.selectTime": "Por favor selecciona una hora de inicio.",
  "amenities.wizard.acceptTerms": "Debes aceptar el reglamento y términos para continuar.",

  "amenities.modal.selectStartTime": "Selecciona hora de inicio",
  "amenities.modal.bookingRange": "Reservación",
  "amenities.modal.hoursLabel": "hrs",
  "amenities.modal.checkingAvailability": "Verificando disponibilidad...",
  "amenities.modal.loadingAvailability": "Verificando disponibilidad...",
  "amenities.modal.closedDay": "El área está cerrada este día.",
  "amenities.modal.blackoutDate": "Esta fecha no está disponible para reservaciones.",

  "amenities.legend.selected": "Seleccionado",
  "amenities.legend.available": "Disponible",
  "amenities.legend.occupied": "Ocupado",
  "amenities.legend.past": "Pasado",

  "amenities.noRules": "No hay reglas específicas para esta área.",
  "amenities.genericTerms": "Al realizar esta reservación, el usuario se compromete a respetar el reglamento del área, mantenerla en buen estado y hacerse responsable de cualquier daño causado durante el tiempo de uso. El incumplimiento puede resultar en la pérdida del depósito o restricciones de acceso futuras.",

  // Admin
  "admin.title": "Panel de Administración",
  "admin.section.community": "Comunidad y Residentes",
  "admin.section.finance": "Finanzas y Pagos",
  "admin.section.security": "Seguridad y Dispositivos",
  "admin.section.platform": "Plataforma",

  "admin.card.users": "Residentes",
  "admin.card.users.desc": "Gestionar perfiles, inquilinos y contratos.",
  "admin.card.residents": "Residentes",
  "admin.card.residents.desc": "Gestionar residentes, propietarios e inquilinos.",
  "admin.card.staff": "Equipo",
  "admin.card.staff.desc": "Administradores, guardias y personal operativo.",
  "admin.card.roles": "Roles",
  "admin.card.roles.desc": "Configurar roles y permisos personalizados.",
  "admin.card.units": "Unidades",
  "admin.card.units.desc": "Configurar torres, casas y departamentos.",
  "admin.card.amenities": "Amenidades",
  "admin.card.amenities.desc":
    "Configurar áreas comunes, reglas y costos.",
  "admin.card.reservations": "Reservas",
  "admin.card.reservations.desc":
    "Calendario de ocupación y reporte de cargos.",
  "admin.card.payments": "Facturación",
  "admin.card.payments.desc":
    "Validar comprobantes y emitir facturas.",
  "admin.card.expenses": "Egresos",
  "admin.card.expenses.desc": "Control de gastos de mantenimiento.",
  "admin.card.access": "Puntos de Acceso",
  "admin.card.access.desc":
    "Configurar HikCentral, puertas y barreras.",
  "admin.card.lpr": "Cámaras LPR",
  "admin.card.lpr.desc":
    "Gestión de listas blancas y negras vehiculares.",
  "admin.card.announcements": "Comunicados",
  "admin.card.announcements.desc":
    "Publicar noticias y alertas urgentes.",
  "admin.card.settings": "Configuración",
  "admin.card.settings.desc": "Reglas generales, logos y horarios.",

  "admin.users.table.name": "Nombre",
  "admin.users.table.unit": "Unidad",
  "admin.users.table.role": "Rol",
  "admin.users.table.status": "Estado",
  "admin.users.role.owner": "Propietario",
  "admin.users.role.tenant": "Inquilino",

  // User Roles (for display)
  "roles.ADMIN": "Administrador",
  "roles.SECTION_ADMIN": "Administrador de sección",
  "roles.RESIDENT": "Residente",
  "roles.GUARD": "Guardia",
  "roles.STAFF": "Personal",
  "roles.TENANT_USER": "Usuario",
  "roles.FAMILIAR": "Familiar",
  "roles.familiar": "Familiar",
  "admin.users.btn.create": "Nuevo Residente",
  "admin.users.search": "Buscar por nombre, unidad...",
  "admin.users.modal.title": "Datos del Residente",
  "admin.users.modal.block": "Bloquear Acceso",
  "admin.users.modal.unblock": "Desbloquear",
  "admin.users.viewAs": "Ver como",
  "impersonation.banner": "Viendo como {{name}} ({{role}})",
  "impersonation.exit": "Salir",
  "admin.users.status.active": "Activo",
  "admin.users.status.blocked": "Bloqueado",
  "admin.users.status.pending": "Pendiente",

  // Admin Staff
  "admin.staff.title": "Equipo de Trabajo",
  "admin.staff.btn.create": "Nuevo Personal",
  "admin.staff.empty": "No hay miembros del equipo.",

  // Admin Roles
  "admin.roles.title": "Roles y Permisos",
  "admin.roles.btn.create": "Nuevo Rol",
  "admin.roles.empty": "No hay roles personalizados.",
  "admin.roles.system": "Sistema",
  "admin.roles.custom": "Personalizado",
  "admin.roles.permissions": "Permisos",

  // Admin Units
  "admin.units.title": "Gestión de Unidades",
  "admin.units.create": "Nueva Unidad",
  "admin.units.type": "Tipo de Inmueble",
  "admin.units.house": "Casa Independiente",
  "admin.units.apt": "Departamento / Piso",
  "admin.units.unit_select": "Seleccionar Unidad",
  "admin.units.allowed_devices.title": "Puertas asignadas",
  "admin.units.allowed_devices.button": "Puertas",
  "admin.units.allowed_devices.description": "Define qué puertas puede abrir esta unidad. Solo los dispositivos asignados aquí estarán disponibles para los residentes y huéspedes de esta unidad.",
  "admin.units.allowed_devices.assigned": "Dispositivos asignados",
  "admin.units.allowed_devices.add_device": "Agregar dispositivo",
  "admin.units.allowed_devices.select_device": "Seleccionar un dispositivo...",
  "admin.units.allowed_devices.no_available": "No hay más dispositivos disponibles",
  "admin.units.allowed_devices.empty": "Esta unidad aún no tiene puertas asignadas.",
  "admin.units.allowed_devices.added": "Dispositivo asignado",
  "admin.units.allowed_devices.already_assigned": "El dispositivo ya estaba asignado",
  "admin.units.allowed_devices.removed": "Dispositivo eliminado",
  "admin.units.allowed_devices.remove": "Eliminar dispositivo",
  "admin.units.allowed_devices.load_error": "Error al cargar dispositivos",
  "admin.units.allowed_devices.add_error": "Error al asignar dispositivo",
  "admin.units.allowed_devices.remove_error": "Error al eliminar dispositivo",

  // Admin Amenities
  "admin.amenities.title": "Gestión de Amenidades",
  "admin.amenities.create": "Nueva Amenidad",
  "admin.amenities.name": "Nombre del Área",
  "admin.amenities.capacity": "Aforo Máximo",
  "admin.amenities.cost": "Costo por Hora",
  "admin.amenities.deposit": "Requiere Depósito",
  "admin.amenities.deposit_amt": "Monto del Depósito",
  "admin.amenities.min_hours": "Horas Mínimas",
  "admin.amenities.max_hours": "Horas Máximas",
  "admin.amenities.image": "Imagen de Portada",
  "admin.amenities.upload": "Subir Imagen",
  "admin.amenities.rules": "Reglamento de Uso",
  "admin.amenities.terms": "Términos y Condiciones",

  // Admin Reservations
  "admin.reservations.title": "Registro de Reservaciones",
  "admin.reservations.id": "ID Reserva",
  "admin.reservations.user": "Usuario",
  "admin.reservations.refund_deposit": "Devolver Depósito",
  "admin.reservations.refunded": "Dep. Devuelto",

  // Admin Finance
  "admin.finance.title": "Gestión Financiera",
  "admin.finance.generate_btn": "Generar Cuotas Mensuales",
  "admin.finance.table.user": "Residente",
  "admin.finance.table.period": "Concepto / Periodo",
  "admin.finance.table.amount": "Monto",
  "admin.finance.table.due": "Vencimiento",
  "admin.finance.table.status": "Estado",
  "admin.finance.modal.title": "Generar Mantenimiento Masivo",
  "admin.finance.modal.period": "Periodo (Ej. Noviembre 2023)",
  "admin.finance.modal.amount": "Monto Estándar",
  "admin.finance.modal.due_date": "Fecha Límite de Pago",
  "admin.finance.modal.generate": "Generar Cargos",
  "admin.finance.modal.success":
    "Cargos generados exitosamente.",
  "admin.finance.register_pay": "Registrar Pago",
  "admin.finance.pay_modal.title": "Registro de Pago",
  "admin.finance.pay_modal.method": "Método de Pago",
  "admin.finance.pay_modal.ref": "Referencia / Folio",
  "admin.finance.pay_modal.date": "Fecha del Pago",
  "admin.finance.pay_modal.notes": "Comentarios",
  "admin.finance.pay_modal.methods.cash": "Efectivo",
  "admin.finance.pay_modal.methods.transfer":
    "Transferencia / SPEI",
  "admin.finance.pay_modal.methods.card":
    "Tarjeta Crédito/Débito",
  "admin.finance.pay_modal.methods.check": "Cheque",
  "admin.finance.filter.search": "Buscar residente...",
  "admin.finance.filter.all": "Todos los estados",
  "admin.finance.filter.paid": "Pagados",
  "admin.finance.filter.pending": "Pendientes",
  "admin.finance.filter.overdue": "Vencidos",
  "admin.finance.filter.verifying": "Por Verificar",

  // Admin Expenses
  "admin.expenses.title": "Gestión de Egresos",
  "admin.expenses.create": "Registrar Gasto",
  "admin.expenses.table.concept": "Concepto",
  "admin.expenses.table.provider": "Proveedor",
  "admin.expenses.table.category": "Categoría",
  "admin.expenses.table.amount": "Monto",
  "admin.expenses.table.date": "Fecha",
  "admin.expenses.modal.title": "Nuevo Gasto",
  "admin.expenses.modal.desc": "Descripción del gasto",
  "admin.expenses.modal.category": "Categoría Contable",
  "admin.expenses.modal.amount": "Monto Total",
  "admin.expenses.modal.provider":
    "Proveedor / Beneficiario",
  "admin.expenses.modal.date": "Fecha del Gasto",
  "admin.expenses.modal.receipt":
    "Adjuntar Factura/Recibo",
  "admin.expenses.cat.maintenance": "Mantenimiento General",
  "admin.expenses.cat.utilities": "Servicios Públicos (Luz/Agua/Gas)",
  "admin.expenses.cat.salaries": "Sueldos y Salarios",
  "admin.expenses.cat.cleaning": "Limpieza",
  "admin.expenses.cat.security": "Seguridad",
  "admin.expenses.cat.insurance": "Seguros",
  "admin.expenses.cat.services": "Servicios",
  "admin.expenses.cat.payroll": "Nómina / Personal",
  "admin.expenses.cat.supplies": "Insumos",
  "admin.expenses.cat.refund": "Devolución Depósitos",
  "admin.expenses.cat.other": "Otros",

  // Admin Charges (Cargos)
  "admin.charges.status.pending": "Pendiente",
  "admin.charges.status.partial": "Parcial",
  "admin.charges.status.paid": "Pagado",
  "admin.charges.status.cancelled": "Cancelado",
  "admin.charges.filter.allStatuses": "Todos",
  "admin.charges.filter.pending": "Pendientes",
  "admin.charges.filter.partial": "Parciales",
  "admin.charges.filter.paid": "Pagados",
  "admin.charges.filter.cancelled": "Cancelados",
  "admin.charges.filter.allTypes": "Todos los tipos",
  "admin.charges.type.maintenance": "Mantenimiento",
  "admin.charges.type.fine": "Multa",
  "admin.charges.type.lateFee": "Recargo",
  "admin.charges.type.extra": "Extra",
  "admin.charges.type.service": "Servicio",
  "admin.charges.type.deposit": "Depósito",
  "admin.charges.type.other": "Otro",

  // Payment methods
  "finance.method.cash": "Efectivo",
  "finance.method.transfer": "Transferencia",
  "finance.method.card": "Tarjeta",
  "finance.method.check": "Cheque",

  // Admin Invoicing
  "admin.invoicing.title": "Facturación y Conciliación",
  "admin.invoicing.tab.verify": "Verificación de Comprobantes",
  "admin.invoicing.tab.emit": "Emisión de Facturas",
  "admin.invoicing.verify.modal.title":
    "Validar Comprobante de Pago",
  "admin.invoicing.verify.approve": "Aprobar Pago",
  "admin.invoicing.verify.reject": "Rechazar Pago",
  "admin.invoicing.verify.reject_reason":
    "Motivo de rechazo",
  "admin.invoicing.emit.rfc": "RFC",
  "admin.invoicing.emit.btn": "Timbrar Factura",
  "admin.invoicing.emit.success":
    "Factura timbrada exitosamente",
  "admin.invoicing.emit.no_fiscal": "Sin datos fiscales",
  "admin.invoicing.emit.invoiced": "Facturado",
  "admin.invoicing.status.verifying": "Verificando",
  "admin.invoicing.proof": "Comprobante",
  "admin.invoicing.download_xml": "XML",
  "admin.invoicing.download_pdf": "PDF",

  // Admin Devices
  "admin.devices.title": "Dispositivos de Acceso",
  "admin.devices.create": "Nuevo Dispositivo",
  "admin.devices.table.name": "Nombre / Ubicación",
  "admin.devices.table.type": "Tipo",
  "admin.devices.table.ip": "Dirección IP",
  "admin.devices.table.status": "Estado",
  "admin.devices.modal.title": "Configurar Dispositivo",
  "admin.devices.type.pedestrian": "Puerta Peatonal",
  "admin.devices.type.vehicle": "Barrera Vehicular",
  "admin.devices.type.controller": "Controladora",
  "admin.devices.type.camera": "Cámara LPR",
  "admin.devices.status.online": "En Línea",
  "admin.devices.status.offline": "Desconectado",

  // Admin LPR
  "admin.lpr.title": "Cámaras LPR y Placas",
  "admin.lpr.tab.live": "Monitoreo en Vivo",
  "admin.lpr.tab.manage": "Gestión de Placas",
  "admin.lpr.table.plate": "Placa",
  "admin.lpr.table.alias": "Propietario / Alias",
  "admin.lpr.table.status": "Estado",
  "admin.lpr.status.whitelist": "Lista Blanca",
  "admin.lpr.status.blacklist": "Lista Negra",
  "admin.lpr.modal.title": "Registrar Placa",
  "admin.lpr.modal.plate": "Número de Placa",
  "admin.lpr.modal.alias": "Nombre / Unidad",
  "admin.lpr.modal.notes":
    "Notas (Razón de bloqueo)",
  "admin.lpr.live.camera": "Cámara Principal",
  "admin.lpr.live.last": "Última detección",

  // Admin Announcements
  "admin.ann.title": "Comunicados y Noticias",
  "admin.ann.create": "Nuevo Comunicado",
  "admin.ann.modal.title": "Redactar Noticia",
  "admin.ann.modal.title_field": "Título del Comunicado",
  "admin.ann.modal.content": "Contenido / Mensaje",
  "admin.ann.modal.priority": "Tipo de Anuncio",
  "admin.ann.modal.expires": "Fecha de Expiración",
  "admin.ann.modal.attach": "Adjuntar Archivo (PDF/IMG)",
  "admin.ann.modal.poll": "Crear Votación",
  "admin.ann.modal.poll_q": "Pregunta de la encuesta",
  "admin.ann.modal.poll_opt":
    "Opciones (Una por línea)",
  "admin.ann.modal.add_opt": "Agregar Opción",

  "admin.ann.priority.urgent": "Urgente",
  "admin.ann.priority.important": "Importante",
  "admin.ann.priority.info": "Informativo",
  "admin.ann.priority.event": "Evento",
  "admin.ann.vote_btn": "Votar",
  "admin.ann.votes": "votos",
  "admin.ann.attach_view": "Ver Adjunto",

  // Admin Settings
  "admin.settings.title": "Configuración del Sistema",
  "admin.settings.tab.general": "General",
  "admin.settings.tab.financial": "Financiero",
  "admin.settings.tab.integrations": "Integraciones",
  "admin.settings.section.identity":
    "Identidad y Contacto",
  "admin.settings.section.rules": "Reglas de Negocio",
  "admin.settings.section.security": "Seguridad",
  "admin.settings.condo_name": "Nombre del Condominio",
  "admin.settings.address": "Dirección",
  "admin.settings.contact_email":
    "Email de Administración",
  "admin.settings.contact_phone": "Teléfono de Oficina",
  "admin.settings.emergency_phone":
    "Teléfono de Emergencia",
  "admin.settings.website": "Sitio Web",
  "admin.settings.visitor_limit":
    "Límite de visitas activas por unidad",
  "admin.settings.maintenance_fee":
    "Cuota de Mantenimiento (Default)",
  "admin.settings.currency": "Moneda",
  "admin.settings.success":
    "Configuración guardada correctamente.",

  "admin.settings.bank.title":
    "Cuenta Bancaria (Depósitos)",
  "admin.settings.bank.name": "Banco",
  "admin.settings.bank.account": "Nombre Titular",
  "admin.settings.bank.number": "No. Cuenta",
  "admin.settings.bank.clabe": "CLABE Interbancaria",

  "admin.settings.fiscal.title": "Datos Fiscales (Emisor)",
  "admin.settings.fiscal.rfc": "RFC Emisor",
  "admin.settings.fiscal.name": "Razón Social",
  "admin.settings.fiscal.regime": "Régimen Fiscal",
  "admin.settings.fiscal.zip": "Código Postal",

  // Integration Marketplace
  "admin.settings.integrations.title":
    "Mercado de Integraciones",
  "admin.settings.integrations.desc":
    "Conecta tus aplicaciones favoritas para automatizar procesos.",
  "admin.settings.integrations.category.all": "Todas",
  "admin.settings.integrations.category.access":
    "Accesos y Seguridad",
  "admin.settings.integrations.category.payment":
    "Pagos en línea",
  "admin.settings.integrations.category.comm":
    "Comunicación",
  "admin.settings.integrations.category.cloud":
    "Nube y Servicios",
  "admin.settings.integrations.status.connected":
    "Conectado",
  "admin.settings.integrations.status.disconnected":
    "Desconectado",
  "admin.settings.integrations.btn.connect": "Conectar",
  "admin.settings.integrations.btn.configure":
    "Configurar",
  "admin.settings.integrations.modal.title":
    "Configuración de Integración",
  "admin.settings.integrations.modal.enable":
    "Habilitar servicio",
  "admin.settings.integrations.key": "API Key / Token",
  "admin.settings.integrations.secret": "Secret Key",
  "admin.settings.integrations.url": "Server URL",

  "admin.settings.integrations.hik": "HikCentral",
  "admin.settings.integrations.hik.desc":
    "Plataforma centralizada de seguridad de Hikvision.",
  "admin.settings.integrations.hikCentral": "HikCentral",
  "admin.settings.integrations.hikCentral.desc":
    "Plataforma centralizada de seguridad de Hikvision.",
  "admin.settings.integrations.dahua": "Dahua DSS",
  "admin.settings.integrations.dahua.desc":
    "Gestión de videovigilancia y control de acceso Dahua.",
  "admin.settings.integrations.zkteco": "ZKTeco BioSecurity",
  "admin.settings.integrations.zkteco.desc":
    "Control de acceso biométrico y asistencia.",

  "admin.settings.integrations.stripe": "Stripe",
  "admin.settings.integrations.stripe.desc":
    "Pagos con tarjeta de crédito/débito internacionales.",
  "admin.settings.integrations.mercadopago": "MercadoPago",
  "admin.settings.integrations.mercadopago.desc":
    "Pasarela de pagos líder en Latinoamérica.",
  "admin.settings.integrations.conekta": "Conekta",
  "admin.settings.integrations.conekta.desc":
    "Pagos en efectivo (OXXO Pay) y transferencias.",

  "admin.settings.integrations.whatsapp": "WhatsApp API",
  "admin.settings.integrations.whatsapp.desc":
    "Envío de QR y notificaciones oficiales (Meta).",
  "admin.settings.integrations.twilio": "Twilio SMS",
  "admin.settings.integrations.twilio.desc":
    "Mensajería SMS y voz programable.",
  "admin.settings.integrations.smtp": "Servidor SMTP",
  "admin.settings.integrations.smtp.desc":
    "Configuración de correo electrónico personalizado.",

  "admin.settings.integrations.aws": "AWS S3",
  "admin.settings.integrations.aws.desc":
    "Almacenamiento seguro para documentos y evidencia.",

  // Integration Catalog
  "admin.settings.integrations.test": "Probar Conexión",
  "admin.settings.integrations.test.success": "Conexión exitosa ({time}ms)",
  "admin.settings.integrations.test.failed": "Conexión fallida: {error}",
  "admin.settings.integrations.testing": "Probando...",
  "admin.settings.integrations.configured": "Configurado",
  "admin.settings.integrations.notConfigured": "No configurado",
  "admin.settings.integrations.saving": "Guardando...",
  "admin.settings.integrations.saved": "Configuración guardada",
  "admin.settings.integrations.errorSaving": "Error al guardar la configuración",
  "admin.settings.integrations.errorLoading": "Error al cargar integraciones",
  "admin.settings.integrations.lastUsed": "Último uso",
  "admin.settings.integrations.errors": "errores",
  "admin.settings.integrations.showOptional": "Mostrar campos opcionales",
  "admin.settings.integrations.hideOptional": "Ocultar campos opcionales",

  // Tickets
  "tickets.title": "Reportes e Incidencias",
  "tickets.create": "Nuevo Reporte",
  "tickets.empty": "No hay reportes registrados.",
  "tickets.status.new": "Nuevo",
  "tickets.status.in_review": "Revisión",
  "tickets.status.in_process": "En Proceso",
  "tickets.status.resolved": "Resuelto",
  "tickets.category.leak": "Fuga de Agua",
  "tickets.category.lighting": "Alumbrado",
  "tickets.category.security": "Seguridad",
  "tickets.category.complaint": "Queja / Ruido",
  "tickets.category.lost_pet": "Mascota Perdida",
  "tickets.category.other": "Otro",
  "tickets.modal.title": "Crear Reporte",
  "tickets.modal.subject": "Asunto del problema",
  "tickets.modal.desc": "Descripción detallada",
  "tickets.modal.category": "Tipo de Incidencia",
  "tickets.modal.photo": "Foto / Evidencia",
  "tickets.detail.title": "Detalle del Reporte",
  "tickets.chat.placeholder": "Escribe un mensaje...",
  "tickets.reportedBy": "Reportado por",
  "tickets.chat.send": "Enviar",
  "tickets.admin.status_change": "Actualizar Estado",

  // Payments Resident
  "payments.title": "Pagos y Mantenimiento",
  "payments.balance": "Saldo Total a Pagar",
  "payments.pay_total": "Pagar Totalidad",
  "payments.history": "Historial de Pagos",
  "payments.table.period": "Periodo",
  "payments.table.due": "Fecha Límite",
  "payments.table.amount": "Monto",
  "payments.table.status": "Estado",
  "payments.table.actions": "Acciones",
  "payments.status.paid": "Pagado",
  "payments.status.pending": "Pendiente",
  "payments.status.overdue": "Vencido",
  "payments.status.verifying": "Verificando",
  "payments.btn.pay": "Pagar Ahora",
  "payments.btn.invoice": "Factura",
  "payments.modal.title": "Realizar Pago",
  "payments.modal.amount": "Monto a Pagar",
  "payments.modal.tab.card": "Tarjeta Crédito/Débito",
  "payments.modal.tab.transfer": "Transferencia SPEI",
  "payments.modal.card.holder": "Nombre del Titular",
  "payments.modal.card.number": "Número de Tarjeta",
  "payments.modal.card.exp": "Vencimiento",
  "payments.modal.card.cvv": "CVV",
  "payments.modal.transfer.bank": "Banco",
  "payments.modal.transfer.beneficiary": "Beneficiario",
  "payments.modal.transfer.clabe": "CLABE Interbancaria",
  "payments.modal.transfer.upload": "Subir Comprobante",
  "payments.modal.transfer.ref": "Referencia / Folio",
  "payments.modal.success_card": "Pago procesado correctamente.",
  "payments.modal.success_transfer": "Comprobante enviado a revisión.",
  "payments.pendingCharges": "Cargos pendientes",
  "payments.paymentHistory": "Historial de pagos",
  "payments.historyEmpty": "No hay pagos en el historial",
  "payments.downloadInvoice": "Descargar Factura",
  "payments.amount": "Monto",
  "payments.dueDate": "Fecha de vencimiento",
  "payments.status": "Estado",
  "payments.uploadReceipt": "Subir Comprobante",
  "payments.paymentMethod": "Método de Pago",
  "payments.paymentReceipt": "Comprobante de Pago",
  "payments.selectFile": "Seleccionar archivo",
  "payments.reference": "Referencia",
  "payments.folio": "Folio",
  "payments.notes": "Notas",
  "payments.notesPlaceholder": "Información adicional...",
  "payments.cancel": "Cancelar",
  "payments.sendProof": "Enviar Comprobante",
  "payments.noPendingCharges": "No hay cargos pendientes",
  "payments.selectedFile": "Archivo seleccionado",
  "payments.referencePlaceholder": "Referencia o Folio",
  "payments.chargesToPay": "Cargos a Pagar",
  "payments.total": "Total",
  "payments.bankInfo": "Información Bancaria",
  "payments.bank": "Banco",
  "payments.beneficiary": "Beneficiario",
  "payments.clabe": "CLABE",
  "payments.transfer": "Transferencia",
  "payments.cash": "Efectivo",
  "payments.check": "Cheque",
  "payments.na": "N/A",
  "payments.rejectionReason": "Motivo del rechazo",
  "payments.pending": "Pendiente",
  "payments.overdue": "Vencido",
  "payments.date": "Fecha",
  "payments.method": "Método",
  "payments.concept": "Concepto",
  "payments.de": "de",
  "payments.noPaymentHistory": "No hay historial de pagos.",
  "payments.paySelected": "Pagar Seleccionados",
  "payments.upToDateWithPayments": "Estás al día con tus pagos",
  "payments.overdueCount": "Cargos vencidos",
  "payments.outstandingBalance": "Saldo pendiente",
  "dashboard.upcomingReservations": "Próximas reservaciones",
  "payments.pendingCount": "Cargos pendientes",
  "payments.currentBalance": "Saldo actual",
  "payments.totalCharges": "Total de cargos",
  "payments.totalPayments": "Total de pagos",
  "payments.overdueAmount": "Monto vencido",
  "payments.card": "Tarjeta",

  // Common
  "common.copied": "Copiado",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.share": "Compartir",
  "common.close": "Cerrar",
  "common.save": "Guardar",
  "common.back": "Volver",
  "common.error": "Ocurrió un error",
  "common.loading": "Cargando...",
  "common.email": "Email",
  "common.phone": "Teléfono",
  "common.tower": "Torre",
  "common.unit": "Unidad / Num",
  "common.role": "Rol",
  "common.street": "Calle",
  "common.block": "Manzana",
  "common.floor": "Piso",
  "common.ext_num": "Num. Exterior",
  "common.int_num": "Num. Interior",
  "common.show": "Mostrar",
  "common.hide": "Ocultar",

  // Cambio de residencial (cada tenant es una cuenta con su propia contraseña)
  "tenantSwitch.subtitle": "Panel Residencial",
  "tenantSwitch.title": "Cambiar de residencial",
  "tenantSwitch.description": "Cada residencial tiene su propia cuenta. Ingresa la contraseña de {tenant} para entrar.",
  "tenantSwitch.passwordLabel": "Contraseña de ese residencial",
  "tenantSwitch.confirm": "Entrar",
  "tenantSwitch.error": "No se pudo cambiar de residencial",
  "common.cancel": "Cancelar",
  "common.all": "Todos",
  "common.savedSuccessfully": "Guardado correctamente",

  // Tickets
  "tickets.no_results": "No hay reportes con este filtro",

  // Notifications
  "notifications.title": "Notificaciones",
  "notifications.empty": "No tienes notificaciones",
  "notifications.noNotifications": "Las notificaciones aparecerán aquí",
  "notifications.markAllRead": "Marcar todas como leídas",
  "notifications.viewAll": "Ver todas las notificaciones",
  "notifications.markedAsRead": "Notificación marcada como leída",
  "notifications.allMarkedAsRead": "Todas las notificaciones marcadas como leídas",
  "notifications.errorLoading": "Error al cargar notificaciones",
  "notifications.errorMarkingRead": "Error al marcar como leída",
  "notifications.errorMarkingAllRead": "Error al marcar todas como leídas",
  "notifications.errorNavigating": "No se pudo abrir la notificación",
  "notifications.unreadCount": "{count} sin leer",
  "notifications.allRead": "No tienes notificaciones sin leer",
  "notifications.filterAll": "Todas",
  "notifications.filterUnread": "No leídas",
  "notifications.filterRead": "Leídas",
  "notifications.tryDifferentFilter": "Prueba con otro filtro",
  "notifications.channelAll": "Todos",
  "notifications.channelInApp": "En App",
  "notifications.channelEmail": "Correo",
  "notifications.channelPush": "Push",
  "notifications.preferences": "Preferencias de notificaciones",
  "notifications.preferences.push": "Notificaciones Push",
  "notifications.preferences.email": "Correo electrónico",
  "notifications.preferences.sms": "SMS",
  "notifications.preferences.whatsapp": "WhatsApp",
  "notifications.preferences.inApp": "En la aplicación",
  "notifications.preferences.quietHours": "Horario silencioso",
  "notifications.preferences.quietStart": "Hora de inicio",
  "notifications.preferences.quietEnd": "Hora de fin",
  "notifications.preferences.emailDigest": "Resumen de correo",
  "notifications.preferences.emailDigest.off": "Desactivado",
  "notifications.preferences.emailDigest.daily": "Diario",
  "notifications.preferences.emailDigest.weekly": "Semanal",
  "notifications.preferences.saved": "Preferencias guardadas",
  "notifications.send": "Enviar notificación",
  "notifications.sendBulk": "Envío masivo",

  // Polls
  "polls.title": "Encuestas",
  "polls.empty": "No hay encuestas activas",
  "announcements.empty": "No hay comunicados",
  "polls.vote": "Votar",
  "polls.voted": "Ya votaste",
  "polls.closed": "Encuesta cerrada",
  "polls.results": "Resultados",
  "polls.ends": "Termina",
  "polls.totalVotes": "votos totales",
  "polls.selectOption": "Selecciona una opción",
  "polls.selectOptions": "Selecciona una o más opciones",
  "polls.voting": "Votando...",
  "polls.voteSuccess": "Voto registrado correctamente",
  "polls.status.draft": "Borrador",
  "polls.status.active": "Activa",
  "polls.status.closed": "Cerrada",
  "polls.admin.title": "Gestión de Encuestas",
  "polls.admin.create": "Nueva Encuesta",
  "polls.admin.createAgain": "Crear encuesta de nuevo",
  "polls.admin.publish": "Publicar",
  "polls.admin.close": "Cerrar",
  "polls.admin.recreate": "Recrear Encuesta",
  "polls.admin.delete": "Eliminar",
  "polls.admin.viewResults": "Ver Resultados",
  "polls.admin.published": "Encuesta publicada",
  "polls.admin.closed": "Encuesta cerrada",
  "polls.admin.deleted": "Encuesta eliminada",
  "polls.form.title": "Título de la encuesta",
  "polls.form.description": "Descripción (opcional)",
  "polls.form.options": "Opciones",
  "polls.form.addOption": "Agregar opción",
  "polls.form.allowMultiple": "Permitir múltiples respuestas",
  "polls.form.isAnonymous": "Votación anónima",
  "polls.form.startsAt": "Fecha de inicio",
  "polls.form.endsAt": "Fecha de fin",
  "polls.form.minOptions": "Se requieren al menos 2 opciones",
  "polls.changeVote": "Cambiar voto",
  "polls.changeVoteConfirm.title": "Cambiar voto",
  "polls.changeVoteConfirm.message": "¿Estás seguro de que deseas cambiar tu voto? Tu voto anterior será reemplazado.",
  "polls.changeVoteConfirm.confirm": "Sí, cambiar",
  "polls.tabs.active": "Activas",
  "polls.tabs.closed": "Cerradas",
  "polls.emptyClosed": "No hay encuestas cerradas",
  "polls.participation": "de",
  "polls.participationUnits": "unidades",
  "polls.selectUnit": "Selecciona unidad para votar",
  "polls.selectUnitPlaceholder": "Selecciona tu unidad...",
  "polls.votingAsUnit": "Votando como unidad",
  "polls.detailedVotes": "Detalle de votos",
  "polls.detailedVotes.voter": "Votante",
  "polls.detailedVotes.option": "Opcion",
  "polls.detailedVotes.unit": "Unidad",
  "polls.detailedVotes.date": "Fecha",
  "polls.detailedVotes.empty": "No hay votos detallados disponibles",
  "polls.detailedVotes.anonymous": "Esta encuesta es anonima. No se muestran los votos individuales.",
  "polls.error.onlyTitulares": "Solo los titulares de unidad pueden votar en esta encuesta",
  "polls.error.unitRequired": "Debes seleccionar una unidad para votar",
  "polls.error.unitNotBelongsToUser": "La unidad seleccionada no te pertenece",
  "polls.error.pollNotActive": "Esta encuesta ya no esta activa",
  "polls.error.pollNotFound": "Encuesta no encontrada",
  "polls.error.generic": "Ocurrio un error al votar",
  "poll.admin.publish.message": "¿Estás seguro de que deseas publicar ",
  "poll.admin.close.message": "¿Estás seguro de que deseas cerrar ",
  "poll.admin.edit.message": "¿Estás seguro de que deseas editar ",


  // Settings
  "settings.title": "Configuración",
  "settings.language": "Idioma",
  "settings.theme": "Tema",
  "settings.darkMode": "Modo Oscuro",
  "settings.lightMode": "Modo Claro",
  "settings.systemDefault": "Predeterminado del Sistema",
  "settings.about": "Acerca de",
  "settings.version": "Versión",
  "settings.termsOfService": "Términos de Servicio",
  "settings.privacyPolicy": "Política de Privacidad",
  "settings.preferences": "Preferencias",
  "settings.support": "Soporte",
  "settings.help": "Ayuda",
  "settings.contactAdmin": "Contactar Administración",
  "settings.terms": "Términos de Servicio",
  "settings.privacy": "Privacidad",
  "settings.security": "Seguridad",

  // Household Members
  "household.title": "Miembros del Hogar",
  "household.addMember": "Agregar Miembro",
  "household.editMember": "Editar Miembro",
  "household.deleteMember": "Eliminar Miembro",
  "household.empty": "No hay miembros del hogar registrados",
  "household.emailRequired": "El correo es obligatorio para crear una cuenta",
  "household.emailHint": "Se enviará un enlace de acceso a este correo",
  "household.name": "Nombre completo",
  "household.relation": "Relación",
  "household.email": "Correo electrónico",
  "household.phone": "Teléfono",
  "household.age": "Edad",
  "household.relations.spouse": "Cónyuge",
  "household.relations.child": "Hijo/a",
  "household.relations.parent": "Padre/Madre",
  "household.relations.other": "Otro",
  "household.accountStatus": "Estado de cuenta",
  "household.status.pending": "Pendiente",
  "household.status.active": "Activo",
  "household.status.inactive": "Inactivo",
  "household.inviteSent": "Invitación enviada a {email}",
  "household.resendInvite": "Reenviar invitación",
  "household.resendSuccess": "Invitación reenviada correctamente",
  "household.deleteConfirm": "¿Estás seguro de eliminar a este miembro del hogar?",

  // Magic Link
  "magicLink.title": "Verificar tu cuenta",
  "magicLink.verifying": "Verificando...",
  "magicLink.success": "¡Cuenta verificada correctamente!",
  "magicLink.error": "Error al verificar",
  "magicLink.expired": "Este enlace ha expirado",
  "magicLink.invalid": "Enlace inválido",
  "magicLink.alreadyUsed": "Este enlace ya fue utilizado",
  "magicLink.requestNew": "Solicitar nuevo enlace",
  "magicLink.requestNewTitle": "Solicitar acceso",
  "magicLink.enterEmail": "Ingresa tu correo electrónico",
  "magicLink.emailSent": "Se ha enviado un nuevo enlace a tu correo",
  "magicLink.selectTenant": "Selecciona tu residencial",
  "magicLink.selectTenantSubtitle": "Tienes acceso a múltiples residenciales",

  // Onboarding
  "onboarding.welcome": "¡Bienvenido a Yawi!",
  "onboarding.welcomeSubtitle": "Tu acceso a la comunidad",
  "onboarding.familiarRole": "Has sido agregado como miembro del hogar",
  "onboarding.whatYouCanDo": "Esto es lo que puedes hacer:",
  "onboarding.features.guests": "Gestionar invitados",
  "onboarding.features.guestsDesc": "Crea y administra códigos de acceso para tus visitas",
  "onboarding.features.announcements": "Ver comunicados",
  "onboarding.features.announcementsDesc": "Mantente informado de las novedades de la comunidad",
  "onboarding.features.polls": "Participar en encuestas",
  "onboarding.features.pollsDesc": "Vota en las encuestas de la comunidad",
  "onboarding.features.accessLogs": "Historial de accesos",
  "onboarding.features.accessLogsDesc": "Consulta el registro de entradas y salidas",
  "onboarding.continue": "Continuar",
  "onboarding.letsStart": "¡Empecemos!",

  // Forgot Password
  "forgotPassword.title": "Recuperar contraseña",
  "forgotPassword.subtitle": "Ingresa tu correo y te enviaremos instrucciones",
  "forgotPassword.email": "Correo electrónico",
  "forgotPassword.submit": "Enviar instrucciones",
  "forgotPassword.sending": "Enviando...",
  "forgotPassword.success": "Revisa tu correo electrónico",
  "forgotPassword.successMessage": "Si el correo existe, recibirás instrucciones para restablecer tu contraseña.",
  "forgotPassword.backToLogin": "Volver al inicio de sesión",

  // Reset Password
  "resetPassword.title": "Nueva contraseña",
  "resetPassword.subtitle": "Ingresa tu nueva contraseña",
  "resetPassword.newPassword": "Nueva contraseña",
  "resetPassword.confirmPassword": "Confirmar contraseña",
  "resetPassword.submit": "Cambiar contraseña",
  "resetPassword.submitting": "Cambiando...",
  "resetPassword.success": "Contraseña actualizada",
  "resetPassword.successMessage": "Tu contraseña ha sido actualizada. Ya puedes iniciar sesión.",
  "resetPassword.requirements": "Mínimo 8 caracteres, una mayúscula, una minúscula y un número",
  "resetPassword.passwordMismatch": "Las contraseñas no coinciden",
  "resetPassword.invalidToken": "El enlace es inválido o ha expirado",
  "resetPassword.requestNew": "Solicitar nuevo enlace",
  "resetPassword.goToLogin": "Ir a iniciar sesión",

  // Logbook (Bitácora)
  "logbook.title": "Bitácora del Guardia",
  "logbook.createEntry": "Nueva Novedad",
  "logbook.shiftHandover": "Cambio de Turno",
  "logbook.noEntries": "No hay novedades registradas",
  "logbook.type.incident": "Incidente",
  "logbook.type.observation": "Observación",
  "logbook.type.delivery": "Paquetería",
  "logbook.type.maintenance": "Mantenimiento",
  "logbook.type.visitor": "Visitante",
  "logbook.type.other": "Otro",
  "logbook.priority.low": "Baja",
  "logbook.priority.medium": "Media",
  "logbook.priority.high": "Alta",
  "logbook.priority.critical": "Crítica",
  "logbook.entryTitle": "Título",
  "logbook.entryDescription": "Descripción",
  "logbook.entryLocation": "Ubicación",
  "logbook.entryCreated": "Novedad registrada",
  "logbook.newEntry": "Nueva Novedad",
  "logbook.searchPlaceholder": "Buscar novedades...",
  "logbook.type.label": "Tipo",
  "logbook.priority.label": "Prioridad",

  "notification.priority.low": "Baja",
  "notification.priority.normal": "Normal",
  "notification.priority.high": "Alta",
  "notification.priority.urgent": "Urgente",
  "logbook.entryUpdated": "Novedad actualizada",
  "logbook.entryDeleted": "Novedad eliminada",
  "logbook.entryViewed": "Novedad vista",
  "logbook.entryEdited": "Novedad editada",
  "logbook.entryType": "Tipo de novedad",
  "logbook.type.novedad": "Novedad",
  "logbook.type.incidente": "Incidente",
  "logbook.type.observacion": "Observación",
  "logbook.type.paqueteria": "Paquetería",
  "logbook.type.mantenimiento": "Mantenimiento",
  "logbook.type.visitante": "Visitante",
  "logbook.type.otro": "Otro",
  "logbook.titlePlaceholder": "Ej. Incidente en el ascensor",
  "logbook.descriptionPlaceholder": "Ej. El ascensor no funciona correctamente",
  "logbook.locationPlaceholder": "Ej. Torre 1, Piso 1, Unidad 1",
  "logbook.photoPlaceholder": "Foto de la novedad",
  "logbook.photoUpload": "Subir foto",
  "logbook.photoRemove": "Eliminar foto",
  "logbook.photoPreview": "Vista previa de la foto",
  "logbook.photoError": "Error al subir la foto",
  "logbook.photoSuccess": "Foto subida correctamente",

  // Patrol (Patrullaje)
  "patrol.rounds": "Rondas",
  "patrol.checkpoints": "Puntos de Control",
  "patrol.startRound": "Iniciar Ronda",
  "patrol.completeRound": "Finalizar Ronda",
  "patrol.scanCheckpoint": "Escanear Punto",
  "patrol.noRounds": "No hay rondas registradas",
  "patrol.noCheckpoints": "No hay puntos de control",
  "patrol.createCheckpoint": "Crear Punto",
  "patrol.checkpointName": "Nombre del Punto",
  "patrol.checkpointLocation": "Ubicación",
  "patrol.status.in_progress": "En Progreso",
  "patrol.status.completed": "Completada",
  "patrol.status.incomplete": "Incompleta",
  "patrol.roundStarted": "Ronda iniciada",
  "patrol.roundCompleted": "Ronda completada",
  "patrol.checkpointScanned": "Punto escaneado",
  "patrol.progress": "Progreso",
  "patrol.scannedAt": "Escaneado",
  "patrol.title": "Patrullaje",
  "patrol.roundsHistory": "Historial de Rondas",
  "patrol.newCheckpoint": "Nuevo Punto",
  "patrol.totalCheckpoints": "Total de Puntos",
  "patrol.activeCheckpoints": "Puntos Activos",
  "patrol.checkpointNamePlaceholder": "Ej. Punto de Control 1",
  "patrol.checkpointLocationPlaceholder": "Ej. Torre 1, Piso 1, Unidad 1",
  "patrol.checkpointDescriptionPlaceholder": "Ej. Punto de control para la torre 1",
  "patrol.checkpointPhotoPlaceholder": "Foto del punto de control",
  "patrol.checkpointPhotoUpload": "Subir foto",
  "patrol.checkpointPhotoRemove": "Eliminar foto",
  "patrol.checkpointPhotoPreview": "Vista previa de la foto",
  "patrol.checkpointPhotoError": "Error al subir la foto",
  "patrol.checkpointPhotoSuccess": "Foto subida correctamente",
  "patrol.locationPlaceholder": "Ej. Torre 1, Piso 1, Unidad 1",
  "patrol.descriptionPlaceholder": "Ej. Punto de control para la torre 1",
  "patrol.orderIndex": "Índice",
  "patrol.orderIndexPlaceholder": "1",
  "patrol.orderIndexRequired": "El índice es requerido",
  "patrol.orderIndexMin": "El índice debe ser mayor a 0",
  "patrol.orderIndexMax": "El índice debe ser menor a 1000",
  "patrol.orderIndexStep": "1",
  "patrol.orderIndexStepPlaceholder": "1",
  "patrol.gpsCoordinates": "Coordenadas GPS",
  "patrol.gpsCoordinatesPlaceholder": "Ej. 19.432834, -99.123456",
  "patrol.gpsCoordinatesRequired": "Las coordenadas GPS son requeridas",
  "patrol.gpsCoordinatesMin": "Las coordenadas GPS deben ser mayor a 0",
  "patrol.gpsCoordinatesMax": "Las coordenadas GPS deben ser menor a 1000",
  "patrol.gpsCoordinatesStep": "1",
  "patrol.gpsCoordinatesStepPlaceholder": "1",
  "patrol.gpsCoordinatesSuccess": "Coordenadas GPS registradas correctamente",
  "patrol.latitude": "Latitud",
  "patrol.longitude": "Longitud",
  "patrol.latitudePlaceholder": "Ej. 19.432834",
  "patrol.longitudePlaceholder": "Ej. -99.123456",
  "patrol.latitudeRequired": "La latitud es requerida",
  "patrol.longitudeRequired": "La longitud es requerida",
  "patrol.latitudeMin": "La latitud debe ser mayor a 0",
  "patrol.longitudeMax": "La longitud debe ser menor a 1000",
  "patrol.filterByStatus": "Filtrar por estado",
  "patrol.status.pending": "Pendiente",
  "patrol.currentRound": "Ronda actual",
  "patrol.autoAssigned": "Asignación automática",
  "patrol.downloadQR": "Descargar QR",
  "patrol.editCheckpoint": "Editar Punto",
  "patrol.useCurrentLocation": "Usar ubicación actual",

  // Suppliers (Proveedores)
  "suppliers.title": "Proveedores",
  "suppliers.directory": "Directorio",
  "suppliers.visits": "Visitas",
  "suppliers.create": "Nuevo Proveedor",
  "suppliers.edit": "Editar Proveedor",
  "suppliers.noSuppliers": "No hay proveedores registrados",
  "suppliers.noVisits": "No hay visitas registradas",
  "suppliers.searchPlaceholder": "Buscar proveedores...",
  "suppliers.category.label": "Categoría",
  "suppliers.category.plomeria": "Plomería",
  "suppliers.category.electricidad": "Electricidad",
  "suppliers.category.jardineria": "Jardinería",
  "suppliers.category.limpieza": "Limpieza",
  "suppliers.category.mantenimiento": "Mantenimiento",
  "suppliers.category.seguridad": "Seguridad",
  "suppliers.category.fumigacion": "Fumigación",
  "suppliers.category.mudanzas": "Mudanzas",
  "suppliers.category.reparaciones": "Reparaciones",
  "suppliers.category.cerrajeria": "Cerrajería",
  "suppliers.category.pintura": "Pintura",
  "suppliers.category.carpinteria": "Carpintería",
  "suppliers.category.aire_acondicionado": "Aire Acondicionado",
  "suppliers.category.albercas": "Albercas",
  "suppliers.category.impermeabilizacion": "Impermeabilización",
  "suppliers.category.otro": "Otro",
  "suppliers.created": "Proveedor creado",
  "suppliers.checkIn": "Registrar Entrada",
  "suppliers.checkOut": "Registrar Salida",
  "suppliers.checkedIn": "Dentro",
  "suppliers.checkedOut": "Finalizada",
  "suppliers.visitPurpose": "Motivo de la visita",
  "suppliers.visitPurposePlaceholder": "Ej. Mantenimiento de jardines",
  "suppliers.authorizedBy": "Autorizado por",
  "suppliers.authorizedByPlaceholder": "Nombre del residente",
  "suppliers.vehiclePlate": "Placa del vehículo",
  "suppliers.registerEntry": "Registrar Entrada",
  "suppliers.visitRegistered": "Visita registrada",
  "suppliers.checkoutSuccess": "Salida registrada",
  "suppliers.registerVisitFor": "Registrar visita de:",
  "suppliers.activeVisits": "Visitas Activas",
  "suppliers.completedVisits": "Visitas Completadas",
  "suppliers.destinationUnit": "Unidad de destino",
  "suppliers.rate": "Calificar",
  "suppliers.enterRating": "Ingrese calificación (1-5):",
  "suppliers.ratingSuccess": "Calificación registrada",
  "suppliers.contactName": "Nombre del contacto",
  "suppliers.contactInfo": "Información de contacto",

  // Inventory (Inventario)
  "inventory.assets": "Activos Fijos",
  "inventory.consumables": "Consumibles",
  "inventory.createAsset": "Nuevo Activo",
  "inventory.editAsset": "Editar Activo",
  "inventory.createConsumable": "Nuevo Consumible",
  "inventory.editConsumable": "Editar Consumible",
  "inventory.noAssets": "No hay activos registrados",
  "inventory.noConsumables": "No hay consumibles registrados",
  "inventory.searchAssets": "Buscar activos...",
  "inventory.searchConsumables": "Buscar consumibles...",
  "inventory.assetName": "Nombre del activo",
  "inventory.assetCode": "Código",
  "inventory.consumableName": "Nombre del consumible",
  "inventory.consumableCode": "Código",
  "inventory.category": "Categoría",
  "inventory.brand": "Marca",
  "inventory.model": "Modelo",
  "inventory.serialNumber": "Número de serie",
  "inventory.location": "Ubicación",
  "inventory.locationPlaceholder": "Ej. Bodega principal, Caseta 1",
  "inventory.purchaseDate": "Fecha de compra",
  "inventory.purchaseValue": "Valor de compra",
  "inventory.currentValue": "Valor actual",
  "inventory.maintenanceInterval": "Intervalo de mantenimiento (días)",
  "inventory.days": "días",
  "inventory.status": "Estado",
  "inventory.status.active": "Activo",
  "inventory.status.maintenance": "En Mantenimiento",
  "inventory.status.retired": "Dado de Baja",
  "inventory.status.lost": "Extraviado",
  "inventory.maintenanceDue": "Mantenimiento requerido",
  "inventory.maintenanceDueWarning": "Activos con mantenimiento pendiente",
  "inventory.nextMaintenance": "Próximo mantenimiento",
  "inventory.generateQR": "Generar QR",
  "inventory.assetCreated": "Activo creado",
  "inventory.consumableCreated": "Consumible creado",
  "inventory.showMaintenanceDueOnly": "Solo con mantenimiento pendiente",
  "inventory.registerMaintenance": "Registrar Mantenimiento",
  "inventory.maintenanceType": "Tipo de mantenimiento",
  "inventory.maintenanceDescription": "Descripción del trabajo",
  "inventory.maintenanceDescriptionPlaceholder": "Ej. Cambio de filtros, lubricación",
  "inventory.performedBy": "Realizado por",
  "inventory.technicianName": "Nombre del técnico",
  "inventory.performedAt": "Fecha de realización",
  "inventory.maintenanceCost": "Costo",
  "inventory.nextMaintenanceAt": "Próximo mantenimiento",
  "inventory.maintenanceCreated": "Mantenimiento registrado",
  "inventory.unit": "Unidad de medida",
  "inventory.minimumStock": "Stock mínimo",
  "inventory.maximumStock": "Stock máximo",
  "inventory.unitCost": "Costo unitario",
  "inventory.currentStock": "Stock actual",
  "inventory.min": "Mín",
  "inventory.max": "Máx",
  "inventory.lowStock": "Stock bajo",
  "inventory.lowStockWarning": "Consumibles con stock bajo",
  "inventory.showLowStockOnly": "Solo con stock bajo",
  "inventory.stockIn": "Entrada",
  "inventory.stockOut": "Salida",
  "inventory.stockAdjustment": "Ajuste",
  "inventory.quantity": "Cantidad",
  "inventory.newStock": "Nuevo stock",
  "inventory.projectedStock": "Stock proyectado",
  "inventory.reason": "Motivo",
  "inventory.reasonPlaceholder": "Ej. Compra mensual, uso para mantenimiento",
  "inventory.referenceNumber": "Número de referencia",
  "inventory.referencePlaceholder": "Ej. Factura, orden de compra",
  "inventory.stockInSuccess": "Entrada registrada",
  "inventory.stockOutSuccess": "Salida registrada",

  // Common additions
  "common.confirm": "Confirmar",
  "common.create": "Crear",
  "common.add": "Agregar",
  "common.description": "Descripción",
  "common.notes": "Notas",
  "common.select": "Seleccionar",
  "common.more": "más",
  "common.viewAll": "Ver todos",
  "common.previous": "Anterior",
  "common.next": "Siguiente",
  "common.inactive": "Inactivo",
  "common.optional": "Opcional",
  "common.required": "Requerido",
  "common.name": "Nombre",
  "common.location": "Ubicación",
  "common.title": "Título",
  "common.titlePlaceholder": "Ej. Incidente en el ascensor",
  "common.descriptionPlaceholder": "Ej. El ascensor no funciona correctamente",
  "common.locationPlaceholder": "Ej. Torre 1, Piso 1, Unidad 1",
  "common.photoPlaceholder": "Foto de la novedad",
  "common.photoUpload": "Subir foto",
  "common.photoRemove": "Eliminar foto",
  "common.photoPreview": "Vista previa de la foto",
  "common.photoError": "Error al subir la foto",
  "common.photoSuccess": "Foto subida correctamente",
  "common.filter": "Filtrar",
  "common.filterPlaceholder": "Buscar...",
  "common.filterBy": "Filtrar por",
  "common.filterByPlaceholder": "Buscar...",
  "common.filterByValue": "Buscar...",
  "common.filterByValuePlaceholder": "Buscar...",
  "common.filterByValueValue": "Buscar...",
  "common.address": "Dirección",


  // Reports
  "reports.title": "Reportes",
  "reports.accountStatement.title": "Estado de Cuenta",
  "reports.delinquent.title": "Reporte de Morosos",
  "reports.annualBilling.title": "Tabla de Cobranza Anual",
  "reports.incomeExpense.title": "Ingresos y Egresos",
  "reports.monthlyStatement.title": "Estado Financiero Mensual",
  "reports.monthlyStatement.description": "Información financiera del mes: ingresos y egresos con detalle y resumen de saldos",
  "reports.journal.title": "Libro Diario (Debe y Haber)",
  "reports.journal.description": "Movimientos del mes en formato contable Debe/Haber con saldo corrido",
  "reports.bankReconciliation.title": "Conciliación Bancaria",
  "reports.bankReconciliation.description": "Compara el saldo según libros contra el estado de cuenta bancario y marca los movimientos conciliados",
  "reports.admin.title": "Admin",
  "reports.resident.title": "Tu Estado de Cuenta",
  "reports.resident.description": "Aquí puedes consultar todos tus cargos y pagos, filtrar por fecha y exportar tu estado de cuenta en diferentes formatos.",
  "reports.admin.description": "Genera y exporta reportes financieros del condominio.",
  "reports.accountStatement.description": "Consulta tu estado de cuenta con todos los cargos y pagos",
  "reports.delinquent.description": "Lista de unidades con cargos vencidos y montos adeudados",
  "reports.annualBilling.description": "Vista mensual de cobranza por unidad con status de pagos",
  "reports.incomeExpense.description": "Flujo de caja con comparativa anual y desglose por categoría",

  // Access Logs (Registro de Accesos)
  "accessLogs.title": "Registro de Accesos",
  "accessLogs.subtitle": "Historial de entradas y salidas del condominio",
  "accessLogs.create": "Registrar Acceso",
  "accessLogs.registerAccess": "Registrar Acceso",
  "accessLogs.noRecords": "No hay registros de acceso",
  "accessLogs.searchPlaceholder": "Buscar por nombre, placa...",
  "accessLogs.accessType": "Tipo de Acceso",
  "accessLogs.accessMethod": "Método",
  "accessLogs.personTypeLabel": "Tipo de Persona",
  "accessLogs.person": "Persona",
  "accessLogs.details": "Método / detalles",
  "accessLogs.registeredBy": "Registrado por",
  "accessLogs.timestamp": "Fecha/Hora",
  "accessLogs.unit": "Unidad",
  "accessLogs.type.entry": "Entrada",
  "accessLogs.type.exit": "Salida",
  "accessLogs.method.manual": "Manual",
  "accessLogs.method.qr": "Código QR",
  "accessLogs.method.rfid": "Tarjeta RFID",
  "accessLogs.method.facial": "Reconocimiento Facial",
  "accessLogs.method.plate": "Lectura de Placa",
  "accessLogs.personType.resident": "Residente",
  "accessLogs.personType.visitor": "Visitante",
  "accessLogs.personType.delivery": "Repartidor",
  "accessLogs.personType.service": "Servicio",
  "accessLogs.personType.employee": "Empleado",
  "accessLogs.personName": "Nombre",
  "accessLogs.personNamePlaceholder": "Nombre completo",
  "accessLogs.personDocument": "Documento/ID",
  "accessLogs.personDocumentPlaceholder": "INE, Pasaporte, etc.",
  "accessLogs.vehiclePlate": "Placa del Vehículo",
  "accessLogs.vehiclePlatePlaceholder": "Ej. ABC-123",
  "accessLogs.selectUnit": "Seleccionar Unidad",
  "accessLogs.notes": "Notas",
  "accessLogs.notesPlaceholder": "Observaciones adicionales...",
  "accessLogs.status": "Estado",
  "accessLogs.personSearch": "Persona",
  "accessLogs.personSearchPlaceholder": "Buscar por nombre",
  "accessLogs.detailSearch": "Detalles",
  "accessLogs.detailSearchPlaceholder": "Buscar en el detalle o motivo",
  "accessLogs.date": "Fecha",
  "accessLogs.entryPoint": "Punto de Acceso",
  "accessLogs.entryPointPlaceholder": "Ej. Acceso Principal",
  "accessLogs.photo": "Foto",
  "accessLogs.perPage": "por página",
  "accessLogs.paginationInfo": "Mostrando {from}-{to} de {total} registros",
  "accessLogs.goToPage": "Ir a pág.",
  "accessLogs.registered": "Acceso registrado correctamente",
  "accessLogs.error.timeout": "La puerta tardó en responder. Vuelve a intentar la apertura.",
  "accessLogs.error.authFailed": "No fue posible abrir en este momento. Intenta de nuevo o acércate a caseta.",
  "accessLogs.error.signatureFailed": "No fue posible abrir en este momento. Intenta de nuevo o acércate a caseta.",
  "accessLogs.error.generic": "No fue posible completar la apertura. Intenta de nuevo.",

  // Shift Status
  "shift.status.active": "Activo",
  "shift.status.completed": "Completado",
  "shift.status.abandoned": "Abandonado",

  // Shift Required Messages
  "shift.required.title": "Turno no iniciado",
  "shift.required.message": "Debes iniciar tu turno antes de poder usar esta función. Tu turno registra todas las actividades que realizas durante tu jornada.",
  "shift.required.action": "Iniciar Turno Ahora",
  "shift.required.hint": "Tu turno se registrará automáticamente",
  "shift.notes.optional": "Notas de inicio (opcional)",
  "shift.notes.placeholder": "Observaciones iniciales...",
  "shift.noShift": "Sin turno activo",
  "shift.startFirst": "Inicia tu turno para continuar",

  // Common additions for Access Logs
  "common.search": "Buscar",
  "common.filters": "Filtros",
  "common.clearFilters": "Limpiar filtros",
  "common.showingOf": "Mostrando {from}-{to} de {total}",

  // Menu additions
  "menu.accessLogs": "Registro de Accesos",

  // Validation errors
  "validation.isString": "Debe ser texto",
  "validation.maxLength": "Máximo {max} caracteres",
  "validation.minLength": "Mínimo {min} caracteres",
  "validation.isEmail": "Debe ser un correo válido",
  "validation.isNotEmpty": "Este campo es requerido",
  "validation.isNumber": "Debe ser un número",
  "validation.isPhoneNumber": "Debe ser un teléfono válido",
  "validation.isBoolean": "Debe ser verdadero o falso",
  "validation.isDate": "Debe ser una fecha válida",
  "validation.isDateString": "Debe ser una fecha válida",
  "validation.isArray": "Debe ser una lista",
  "validation.isUrl": "Debe ser una URL válida",
  "validation.isUuid": "Debe ser un identificador válido",
  "validation.isPositive": "Debe ser un número positivo",
  "validation.max": "El valor máximo es {max}",
  "validation.min": "El valor mínimo es {min}",
  "validation.isEnum": "Debe ser uno de: {values}",
  "validation.unknown": "Valor inválido",

  // Admin Layout V2
  "menu.v2.comingSoon": "Próximamente",
  "menu.v2.myProfile": "Mi Perfil",
  "menu.v2.logout": "Cerrar Sesión",
  "menu.residentes": "Residentes",
  "menu.unidades": "Unidades",
  "menu.secciones": "Secciones",
  "menu.reservas": "Reservas",
  "menu.visitas": "Visitas",
  "menu.personal": "Personal",
  "menu.finanzas": "Finanzas",
  "menu.cuotas": "Cuotas",
  "menu.presupuesto": "Presupuesto",
  "menu.mantenimiento": "Mantenimiento",
  "menu.v2.kpi.ocupacion": "Ocupación",
  "menu.v2.kpi.cobranza": "Cobranza",
  "menu.v2.kpi.satisfaccion": "Satisfacción",
  "menu.v2.kpi.seguridad": "Seguridad",
  "menu.v2.insight.title": "Hommi AI · Insight",
  "menu.v2.insight.desc": "El análisis inteligente de tu condominio estará disponible pronto.",
  "menu.v2.alerts.title": "Alertas Críticas",
  "menu.v2.activity.title": "Actividad en Vivo",
  "menu.v2.finance.title": "Resumen Financiero",
  "menu.v2.lastAccess.title": "Últimos Accesos",
  "menu.v2.camera.title": "Cámara en Tiempo Real",
  "menu.v2.upcoming.title": "Próximos Egresos",
  "menu.v2.search.placeholder": "Buscar unidad, residente o reporte...",
  "menu.v2.status.updated": "Actualizado hace 2 min",
  "menu.v2.accesos": "Accesos",
  "menu.v2.incidentes": "Incidentes",
  "menu.v2.puntosAcceso": "Puntos de acceso",
  "menu.v2.rfid": "Tarjetas RFID",
  "menu.v2.amenidadesReg": "Registro de amenidades",
  "menu.v2.gastos": "Gastos",
  "menu.v2.resumenFinanzas": "Resumen",
  "menu.v2.categorias": "Categorías",
  "menu.v2.notificacionesConfig": "Notificaciones",
  "menu.v2.auditoria": "Auditoría",
  "menu.v2.configuracion": "Configuración",
  "menu.v2.routines": "Rutinas",
  "menu.v2.documents": "Documentos",
  "menu.v2.payments": "Pagos",
  "menu.v2.inicio": "Inicio",
  "menu.v2.actividad": "Actividad",
  "menu.v2.ajustes": "Ajustes",
  "menu.v2.notificacionesReglas": "Reglas de notificación",
  "menu.v2.sidebar.collapse": "Colapsar menú",
  "menu.v2.sidebar.expand": "Expandir menú",

  "routines.title": "Rutinas Programadas",
  "routines.subtitle": "Automatizaciones recurrentes del condominio",
  "routines.search": "Buscar rutina...",
  "routines.filterCategory": "Categoría",
  "routines.filterEnabled": "Estado",
  "routines.allCategories": "Todas las categorías",
  "routines.allStatuses": "Todos los estados",
  "routines.enabled": "Activa",
  "routines.disabled": "Pausada",
  "routines.runNow": "Ejecutar ahora",
  "routines.toggle.enable": "Activar",
  "routines.toggle.disable": "Pausar",
  "routines.delete": "Eliminar",
  "routines.edit": "Editar",
  "routines.create": "Nueva Rutina",
  "routines.executions": "Ver ejecuciones",
  "routines.status.idle": "En espera",
  "routines.status.running": "Ejecutando",
  "routines.status.success": "Exitosa",
  "routines.status.failed": "Fallida",
  "routines.lastRun": "Última ejecución",
  "routines.nextRun": "Próxima ejecución",
  "routines.triggerSummary": "Frecuencia",
  "routines.category.billing": "Facturación",
  "routines.category.access": "Acceso",
  "routines.category.gdpr": "GDPR",
  "routines.category.restrictions": "Restricciones",
  "routines.category.maintenance": "Mantenimiento",
  "routines.category.custom": "Personalizado",
  "routines.category.uncategorized": "Sin categoría",
  "routines.executionStatus.running": "Ejecutando",
  "routines.executionStatus.success": "Exitosa",
  "routines.executionStatus.failed": "Fallida",
  "routines.executionStatus.cancelled": "Cancelada",
  "routines.executionStatus.skipped": "Omitida",
  "routines.noRoutines": "No hay rutinas configuradas",
  "routines.noExecutions": "Sin historial de ejecuciones",
  "routines.form.name": "Nombre",
  "routines.form.description": "Descripción",
  "routines.form.category": "Categoría",
  "routines.form.action": "Acción",
  "routines.form.cronExpression": "Expresión Cron",
  "routines.form.timezone": "Zona horaria",
  "routines.form.enabled": "Activar al crear",
  "routines.form.save": "Guardar",
  "routines.form.cancel": "Cancelar",
  "routines.form.validateCron": "Validar",
  "routines.form.cronValid": "Expresión válida",
  "routines.form.cronInvalid": "Expresión inválida",
  "routines.form.nextRuns": "Próximas ejecuciones:",
  "routines.modal.createTitle": "Nueva Rutina",
  "routines.modal.editTitle": "Editar Rutina",
  "routines.modal.executionsTitle": "Historial de Ejecuciones",
  "routines.deleteConfirm.title": "Eliminar Rutina",
  "routines.deleteConfirm.message": "¿Estás seguro de que deseas eliminar esta rutina? Esta acción no se puede deshacer.",
  "routines.triggerSuccess": "Rutina ejecutada. ID: {{executionId}}",
  "routines.toggleSuccess.enabled": "Rutina activada",
  "routines.toggleSuccess.disabled": "Rutina pausada",
  "routines.deleteSuccess": "Rutina eliminada",
  "routines.createSuccess": "Rutina creada",
  "routines.updateSuccess": "Rutina actualizada",
  "routines.failureCount_one": "{{count}} fallo",
  "routines.failureCount_other": "{{count}} fallos",
  "routines.duration": "{{ms}}ms",
  "routines.resultCount": "{{count}} registros",
  "routines.attempt": "Intento {{n}}",
  "routines.triggered.schedule": "Programada",
  "routines.triggered.manual": "Manual",
  "routines.triggered.retry": "Reintento",

  // Recorridos GPS (Incremento 4)
  "menu.v2.recorridos": "Recorridos",
  "guardRoutes.title": "Recorridos",
  "guardRoutes.subtitle": "Trayectos GPS de los guardias",
  "guardRoutes.guard": "Guardia",
  "guardRoutes.allGuards": "Todos los guardias",
  "guardRoutes.from": "Desde",
  "guardRoutes.to": "Hasta",
  "guardRoutes.clear": "Limpiar filtros",
  "guardRoutes.retry": "Reintentar",
  "guardRoutes.empty": "No hay recorridos con estos filtros",
  "guardRoutes.unknownGuard": "Guardia sin nombre",
  "guardRoutes.inProgress": "Recorrido en curso",
  "guardRoutes.page": "Página {{page}} de {{total}}",
  "guardRoutes.selectRoute": "Elige un recorrido para ver su trazo",
  "guardRoutes.noPoints": "Este recorrido no tiene puntos registrados",
  "guardRoutes.distance": "Distancia",
  "guardRoutes.pace": "Ritmo",
  "guardRoutes.duration": "Tiempo",
  "guardRoutes.stops": "Paradas",
  "guardRoutes.gaps": "Sin señal",
  "guardRoutes.points": "Puntos",
  "guardRoutes.start": "Inicio",
  "guardRoutes.end": "Fin",
  "guardRoutes.stop": "Parada",
};
